import Vue from 'vue'
import {Locale} from 'vant'
import VueI18n from 'vue-i18n'

import Chinese from './cn'
import TWChinese from './tw'
import HKChinese from './hk'
import English from './en'
import Malay from './ms'
import Indonesia from './id'
// import Vietnam from './vi'
import Thai from './th'
// import Portugal from './pt'
// import Spanish from './es'

import zhCN from 'vant/lib/locale/lang/zh-CN'
import zhTW from 'vant/lib/locale/lang/zh-TW'
import zhHK from 'vant/lib/locale/lang/zh-HK'
import enUS from 'vant/lib/locale/lang/en-US'
import thTH from 'vant/lib/locale/lang/th-TH'
import idID from './id-ID'
// import viVN from './vi-VN'
import msMS from './ms-MS'
// import ptBR from './pt-BR'
// import esES from 'vant/lib/locale/lang/es-ES'

export function initLanguage (lang) {
  switch(lang){
    case 'cn':
      Locale.use('zh-CN', zhCN)
      break;
    case 'tw':
      Locale.use('zh-TW', zhTW)
      break;
    case 'hk':
      Locale.use('zh-HK', zhHK)
      break;
    case 'en':
      Locale.use('en-US', enUS)
      break;
    case 'ms':
      Locale.use('ms-MS', msMS)
      break;
    case 'id':
      Locale.use('id-ID', idID)
      break;
    // case 'vi':
    //   Locale.use('vi-VN', viVN)
    //   break;
    case 'th':
      Locale.use('th-TH', thTH)
      break;
    // case 'pt':
    //   Locale.use('pt-BR', ptBR)
    //   break;
    // case 'es':
    //   Locale.use('es-ES', esES)
    //   break;
  }
}

/*初始化*/
const lang = localStorage['Language']||langList[0].lang
initLanguage(lang)

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: lang,
  messages: {
    "cn": Chinese,
    "tw": TWChinese,
    "hk": HKChinese,
    "en": English,
    "ms": Malay,
    "id": Indonesia,
    // "vi": Vietnam,
    "th": Thai,
    // "pt": Portugal,
    // "es": Spanish
  }
})

/*切換*/
export function SetLanguage (lang) {
  i18n.locale = lang
  localStorage['Language'] = lang
  initLanguage(lang)
}
export default i18n